import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchSyllabus = createAsyncThunk(
  "syllabus/fetchSyllabus",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/syllabus_by_class`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching syllabus:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const syllabusSlice = createSlice({
  name: "syllabus",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSyllabus.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchSyllabus.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchSyllabus.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default syllabusSlice.reducer;
